import { createIcon } from '../createIcon';
import { ReactComponent as IconCalendarCheck } from '../svg/calendar-check.svg';

export default createIcon(IconCalendarCheck);
